/**
 @name: 数据有效性判断
 @description:
 @author: 徐朝成 xcc614@qq.com
 @time: 2021-11-16 12:12:50
 **/
import request from '@/http'

export const api = {
  hasData: (data) => request.get(`/team/common/checkDataStatus/${data.type}/${data.no}`),// type: 1工队;2工程公司;3找工人;4临时用工;5工种报价;6劳务用工
}
